import React from "react";

const Signup = () => {
  return (
    <div className="container mt-5">
      <h2>Signup</h2>
      <form>
        <input className="form-control my-2" type="text" placeholder="Name" />
        <input className="form-control my-2" type="email" placeholder="Email" />
        <input
          className="form-control my-2"
          type="password"
          placeholder="Password"
        />
        <button className="btn btn-primary">Register</button>
      </form>
    </div>
  );
};

export default Signup;
